import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'formik';
import Radio from '../../../CommonComponents/Radio';
import { PrimaryButton, SecondaryButton } from '../../../CommonComponents/Button';
import { Answers, Question, StyledQuestions } from './QuestionsStyles';
import { ModalFooter } from '../../ExperianStyles';

const QuestionsForm = ({
  questions,
  values,
  setFieldValue,
  isValid,
  isSubmitting,
  onCancel,
  hasErrors,
}) =>
  hasErrors ? (
    <ModalFooter>
      <SecondaryButton onClick={onCancel} disabled={isSubmitting}>
        Cancel
      </SecondaryButton>
    </ModalFooter>
  ) : (
    <Form>
      <StyledQuestions>
        {questions.map(
          ({
            QuestionNumber: questionNumber,
            QuestionText: questionText,
            VerificationAnswerOptions: answers,
          }) => (
            <React.Fragment key={questionNumber}>
              <Question>{`${questionNumber}. ${questionText}`}</Question>
              <Answers>
                {answers.map(({ AnswerNumber: answerNumber, AnswerText: answerText }) => {
                  const name = `${questionNumber}`;
                  return (
                    <Radio
                      key={`${name}${answerNumber}`}
                      name={name}
                      checked={values[name] === answerNumber}
                      onChange={() => {
                        setFieldValue(name, answerNumber);
                      }}
                    >
                      {answerText}
                    </Radio>
                  );
                })}
              </Answers>
            </React.Fragment>
          ),
        )}
      </StyledQuestions>
      <ModalFooter>
        <SecondaryButton onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </SecondaryButton>
        {!hasErrors && (
          <PrimaryButton type="submit" disabled={!isValid || isSubmitting}>
            Finish
          </PrimaryButton>
        )}
      </ModalFooter>
    </Form>
  );

QuestionsForm.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  values: PropTypes.shape({}).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  hasErrors: PropTypes.bool.isRequired,
};

export default QuestionsForm;
